import { ReactNode } from 'react';
import classes from 'classnames';
import Chevron from 'assets/icons/chevron.svg?react';
import { IconElement } from '../../types/IconElement';
import styles from './AccordionItem.module.scss';

export type AccordionItemProps = {
  title: string;
  Icon?: IconElement;
  children: ReactNode;
  onClick: () => void;
  active: boolean;
  titleClassName?: string;
};

export default function AccordionItem({
  active,
  children,
  title,
  onClick,
  Icon,
  titleClassName,
}: AccordionItemProps) {
  return (
    <div className={styles.container}>
      <button
        className={styles.head}
        onClick={onClick}
        data-test="accordion-item-head"
        role="menuitem"
        type="button"
      >
        <div className={classes(styles.title, titleClassName)}>
          {Icon && (
            <div className={styles.icon}>
              <Icon />
            </div>
          )}
          {title}
        </div>
        <Chevron className={classes(styles.chevron, active && styles.open)} />
      </button>
      <div
        className={classes(
          styles.accordion,
          active ? styles.open : styles.close,
        )}
      >
        <div className={styles.content} data-test="accordion-item-content">
          {children}
        </div>
      </div>
    </div>
  );
}
